export const AKOU_WIDGET_URL = 'https://akou-widget.vercel.app/widget.js';
export const AKOU_BRAIN_URL = 'https://akoubrain-production.up.railway.app';
export const AKOU_PUBLIC_KEY = 'pk_live_0f50df254be1eb18d8afc3a375681aee';
export const AKOU_IFRAME_SELECTOR = 'iframe[title="Akou"]';
export const AKOU_ROUTE_FRAGMENT = '/e-learning';
